import React from "react";
import * as Chakra from "@chakra-ui/react";

interface BodyInputTextProps extends Chakra.BoxProps {
  title: string;
  body: string;
  placeholder: string;
  number?: number;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  value: string;
}

const BodyInputText = ({
  title,
  body,
  placeholder,
  number,
  onChange,
  value,
  ...props
}: BodyInputTextProps): React.ReactElement => {
  return (
    <Chakra.Box width="100%" pt="44px" {...props}>
      <Chakra.Text
        fontSize="14px"
        fontWeight="500"
        lineHeight="20px"
        letterSpacing="0.11px"
        color="#000"
      >
        {title}
      </Chakra.Text>
      <Chakra.Text
        fontSize="14px"
        fontWeight="300"
        lineHeight="20px"
        letterSpacing="0.11px"
        color="#000"
        pb="35px"
        maxWidth="480px"
      >
        {body}
      </Chakra.Text>
      <Chakra.InputGroup width="100%">
        <Chakra.Input
          placeholder={placeholder}
          width="100%"
          borderRadius="2px"
          height="40px"
          borderWidth="1px"
          borderStyle="solid"
          borderColor="#bababa"
          _placeholder={{ fontSize: "14px", color: "#000" }}
          value={value}
          onChange={onChange}
        />
        <Chakra.InputRightElement>
          <Chakra.Text fontSize="13px" color="#c8232a">
            {number ? Math.max(number - value.length, 0) : ""}
          </Chakra.Text>
        </Chakra.InputRightElement>
      </Chakra.InputGroup>
    </Chakra.Box>
  );
};

export default BodyInputText;
